export default __webpack_public_path__ + "static/media/codegen-prompt.06611a6a.md";